module.exports = __webpack_public_path__ + "img/share-svgrepo-com.8aff8377.svg";